import React, { Fragment } from 'react';
import Select, { components } from 'react-select';
import Creatable from 'react-select/creatable';
import AsyncReactSelect from 'react-select/async';
import Loading from 'components/Loading';
import Copy from 'components/Copy';
import { get, isArray, isEmpty, isPlainObject } from 'lodash';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import { TooltipReactTooltip } from 'components/Tooltip';
import { AppRoutes } from 'consts/routesPath';
import classNames from 'classnames';
import CheckBoxField from 'customField/CheckBoxField';
import { cn } from 'helpers/css';
import './select.css';
import { Check, PlusCircle, XCircle } from 'lucide-react';
import { Separator } from 'shadcn/components/separator';
import { Badge } from 'shadcn/components/badge';

const customStyles = {
  control: (base) => {
    return {
      ...base,
      minHeight: 200,
    };
  },
  menuPortal: (base) => {
    return {
      ...base,
      zIndex: 9999,
    };
  },
};

const CustomClearIndicator = (props) => {
  const {
    innerProps: { ref, ...innerProps },
    selectProps,
  } = props;
  const { isQuickView, isCopyAble, hideCloseIcon, onClickQuickView, onClickRedirectPage } =
    selectProps;

  const textShow = () => {
    if (selectProps.customQuickView) {
      return selectProps.customQuickView;
    }

    if (isPlainObject(props.selectProps?.value)) {
      return props.selectProps?.value?.label;
    }

    return props.selectProps?.value;
  };

  const color = 'hsl(0,0%,50%)';
  const size = {
    width: 20,
    height: 20,
  };

  return (
    <div
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onTouchEnd={(e) => {
        e.stopPropagation();
      }}
      style={{ display: 'flex', alignItems: 'center' }}
      className='mr-2'
    >
      {isQuickView && (
        <Fragment>
          <div
            style={{
              ...size,
            }}
            className='d-flex align-items-center justify-content-center flex-shrink-0'
            onClick={onClickRedirectPage}
          >
            <TooltipReactTooltip
              messageToolTip={'Go to detail page'}
              idTarget={`${props.selectProps.name}-go-to`}
              portal={document.body}
            >
              <CommonIcons.RedirectTo size={SIZE_ICON} style={{ color }} className='is-hover' />
            </TooltipReactTooltip>
          </div>

          <div
            style={{
              ...size,
            }}
            className='d-flex align-items-center justify-content-center flex-shrink-0'
            onClick={onClickQuickView}
          >
            <TooltipReactTooltip
              messageToolTip={textShow()}
              idTarget={`${props.selectProps.name}-view`}
              portal={document.body}
            >
              <CommonIcons.EyeOpen size={SIZE_ICON} style={{ color }} className='is-hover' />
            </TooltipReactTooltip>
          </div>
        </Fragment>
      )}
      {isCopyAble && (
        <div
          style={{
            ...size,
          }}
          className='d-flex align-items-center justify-content-center flex-shrink-0'
        >
          <Copy
            id={props.selectProps.name}
            text={
              isPlainObject(props.selectProps?.value)
                ? props.selectProps?.value?.label
                : props.selectProps?.value
            }
            style={{
              marginRight: 0,
              color,
            }}
          />
        </div>
      )}

      {!hideCloseIcon && (
        <div
          {...innerProps}
          ref={ref}
          className='d-flex align-items-center justify-content-center flex-shrink-0'
          style={{ ...size, flexShrink: 0 }}
        >
          <TooltipReactTooltip
            messageToolTip='Clear'
            idTarget={`${props.selectProps.name}-clear`}
            portal={document.body}
          >
            <CommonIcons.Close style={{ color }} className='is-hover' size={SIZE_ICON} />
          </TooltipReactTooltip>
        </div>
      )}
    </div>
  );
};

export const CustomOption = (props) => {
  const { innerProps, isDisabled, children, isSelected, isMulti } = props;
  const { ...newInnerProps } = innerProps;
  if (isDisabled) {
    return null;
  }
  return (
    <div
      {...newInnerProps}
      className={cn(
        `select-custom-dzb`,
        isMulti && 'tw-flex tw-gap-2',
        !isMulti && isSelected && 'is-active'
      )}
    >
      {isMulti && <CheckBoxField key={`${isSelected}`} defaultChecked={isSelected} />}
      {children}
      {isSelected && !isMulti && (
        <Check className='tw-h-4 tw-w-4 tw-float-right tw-translate-y-1' />
      )}
    </div>
  );
};

export const LoadingIndicator = (props) => {
  return <Loading {...props} style={{ paddingRight: 12 }} />;
};

const CustomMultiValue = (props) => {
  const { data, removeProps } = props;
  const extraProps = get(props, 'selectProps.extraProps') || {};
  const isFixed = get(props, 'data.isFixed');

  const { forDomainGroup, forContactGroup, forCreativeGroup, forOfferGroup, forDIDGroup } =
    extraProps;

  const genLink = () => {
    if (forDomainGroup) {
      return AppRoutes.DomainDetailWithId(data.value);
    }

    if (forContactGroup) {
      return AppRoutes.ContactDetailWithId(data.value);
    }

    if (forCreativeGroup) {
      return AppRoutes.CreativeComposeDetailWithId(data.value);
    }

    if (forOfferGroup) {
      return AppRoutes.OffersDetailWithId(data.value);
    }

    if (forDIDGroup) {
      return AppRoutes.DidsDetailWithId(data.value);
    }

    return '#';
  };

  return (
    <div className={classNames('select-multiple-badge', isFixed && 'is-fixed')}>
      <div className='select-multiple-badge__label'>{data.label}</div>
      {!isFixed && !isEmpty(extraProps) && (
        <a
          href={genLink()}
          className='select-multiple-badge__action'
          target='_blank'
          onMouseDown={removeProps.onMouseDown}
          onTouchEnd={removeProps?.onTouchEnd}
        >
          <CommonIcons.RedirectTo />
        </a>
      )}
      {!isFixed && (
        <div {...removeProps} className='select-multiple-badge__action'>
          <CommonIcons.Close />
        </div>
      )}
    </div>
  );
};

const ControlComponent = (props) => {
  console.log('123123', props);
  const { hasValue, selectProps, innerRef, innerProps, getValue, clearValue } = props;
  const { label, value } = selectProps;

  const renderValue = () => {
    if (!hasValue) {
      return null;
    }

    return (
      <Fragment>
        <Separator
          orientation='vertical'
          className='tw-mx-0.5 tw-data-[orientation=vertical]:h-4'
        />
        {isArray(value) &&
          value.map((v, index) => {
            return (
              <Badge
                key={`${index}`}
                variant='secondary'
                className='tw-rounded-sm tw-px-1 tw-font-extrabold'
              >
                {v?.label}
              </Badge>
            );
          })}

        {isPlainObject(value) && (
          <Badge variant='secondary' className='tw-rounded-sm tw-px-1 tw-font-extrabold'>
            {value?.label}
          </Badge>
        )}
      </Fragment>
    );
  };

  return (
    <div className='component:ControlComponent'>
      <div
        {...props.innerProps}
        className='react-select tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-font-medium focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50 [&_svg]:tw-pointer-events-none [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 tw-border tw-border-input tw-bg-background tw-shadow-sm hover:tw-bg-accent dark:hover:tw-bg-[var(--bg-dark-input)] hover:tw-text-accent-foreground dark:tw-bg-[var(--bg-dark)] tw-h-8 tw-rounded-md tw-px-3 tw-text-xs tw-border-dashed tw-relative tw-cursor-pointer'
      >
        <div className='btn-content tw-inline-flex tw-gap-1 tw-items-center tw-flex-wrap'>
          {hasValue ? (
            <span
              onClick={(e) => {
                e.stopPropagation();
                clearValue();
              }}
            >
              <XCircle />
            </span>
          ) : (
            <PlusCircle />
          )}
          {label}
          {renderValue()}
        </div>
      </div>
      <div ref={props.innerRef}></div>

      {/* {props.children} */}
    </div>
  );
};

const MenuList = (props) => {
  const { isMulti, selectProps } = props;
  const valueSelected = selectProps?.value;
  const hasOptions = !isEmpty(props?.options);

  return (
    <components.MenuList {...props}>
      {isMulti && !isEmpty(valueSelected) && (
        <div>
          <p className='tw-p-[6px] tw-text-muted-foreground tw-text-xs'>Selected</p>
          {valueSelected.map((el) => {
            return (
              <div
                className='select-custom-dzb tw-flex tw-gap-2'
                key={el.value}
                onClick={(e) => {
                  e.stopPropagation();
                  props.selectOption(el);
                }}
              >
                <CheckBoxField defaultChecked={true} /> {el.label}
              </div>
            );
          })}
        </div>
      )}
      {hasOptions && <p className='tw-p-[6px] tw-text-muted-foreground tw-text-xs'>Options</p>}
      {props.children}
    </components.MenuList>
  );
};

const SelectCustomize = (props) => {
  const { isCreatable, styles } = props;

  if (isCreatable) {
    return (
      <Creatable
        classNamePrefix='react-select'
        {...props}
        styles={customStyles}
        components={{
          Option: CustomOption,
        }}
      />
    );
  }

  return (
    <Select
      classNamePrefix='react-select'
      {...props}
      styles={{
        ...customStyles,
        ...styles,
      }}
      components={{
        // LoadingIndicator,
        Option: CustomOption,
        MenuList: MenuList,
        ClearIndicator: CustomClearIndicator,
        MultiValue: CustomMultiValue,
      }}
    />
  );
};

export const AsyncSelect = ({ styles, ...props }) => {
  return (
    <AsyncReactSelect
      {...props}
      styles={{
        ...customStyles,
        ...styles,
      }}
      components={{
        MultiValue: CustomMultiValue,
      }}
    />
  );
};

export default SelectCustomize;
